import Introduce from "../../../../src/events/2022/12/introduce/main";
import * as React from 'react';
export default {
  Introduce,
  React
};